

const orders_transformer = async function(response) {
  console.log(response)
  return localStorage["sales_invoice"]
}

export default orders_transformer
